import { render, staticRenderFns } from "./MTList.vue?vue&type=template&id=4dae64e2&scoped=true"
import script from "./MTList.vue?vue&type=script&lang=js"
export * from "./MTList.vue?vue&type=script&lang=js"
import style0 from "./MTList.vue?vue&type=style&index=0&id=4dae64e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dae64e2",
  null
  
)

export default component.exports